import { FunctionComponent, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Link } from '@conexasaude/hero'
import { useThemeGeneratorContext } from '@/theme/contexts/ThemeGeneratorContext'
import breadcrumbStyle from '@/components/Breadcrumb/breadcrumb-style'
import Icon from '@/components/HeroIcons'
import useWindowSize from '@/utils/useWindowSize'

type Item = {
  route: string
  title: string
}

interface IBreacrumbProps {
  items?: Item[]
  currentStep?: number
}

const Breadcrumb: FunctionComponent<IBreacrumbProps> = ({
  currentStep,
  items,
}) => {
  const [filteredItems, setFilteredItems] = useState([])
  const { push } = useHistory()
  const { breadcrumbContainer, backStepContainer } = breadcrumbStyle()
  const { embed } = useThemeGeneratorContext()
  const { isMobile } = useWindowSize()

  const verifyCurrentStep = (index?: number) => {
    return !currentStep
      ? filteredItems.length - 1 === index
      : currentStep === index
  }
  useEffect(() => {
    if (currentStep === null || currentStep === undefined) {
      setFilteredItems(items)
    } else setFilteredItems(items.slice(0, currentStep + 1))
  }, [currentStep, items])

  if (embed?.full) return null

  const verifyBackStep = () => {
    if (filteredItems.length <= 1) {
      push('/')
      return
    }
    const backStep = currentStep || filteredItems.length - 1
    push(filteredItems[backStep - 1].route)
  }

  return (
    <div>
      <ul css={breadcrumbContainer}>
        <li>
          <Link onClick={() => push('/')}>Início</Link>
        </li>
        {filteredItems?.map((item, index) => (
          <li key={item.route}>
            <Icon
              name={'arrow-right'}
              size="24px"
              themeColor={['extra', 'gray_icon']}
            />
            {verifyCurrentStep(index) ? (
              <span className="current-step">{item.title}</span>
            ) : (
              <Link onClick={() => push(item.route)}>{item.title}</Link>
            )}
          </li>
        ))}
      </ul>
      {isMobile ? (
        <div css={backStepContainer}>
          <Icon
            name={'arrow-left'}
            size="24px"
            themeColor={['extra', 'gray_icon']}
          />
          <span onClick={verifyBackStep}> Voltar</span>
        </div>
      ) : null}
    </div>
  )
}
export default Breadcrumb
